<div class="active-facet">{{ label }} <a *ngIf="!isLocked()" (click)="removeClick()"
        attr.aria-label="Remove facet {{ label }}"><span class="fa fa-times"></span></a></div>